import EscalationSupportInfo from './EscalationSupportInfo';

export default EscalationSupportInfo;
